import React from "react";

import { Icon } from "@ui/icons/icon";
import { ICON_COLLECTION } from "@ui/icons/icon-list";
import { Token } from "@/pages/create-fund/components/select-tokens/select-tokens";

export const TokenItem = ({
  token,
  factor,
  fundFactor,
  priceLovelace,
}: {
  token: Token;
  factor?: number;
  fundFactor?: number;
  priceLovelace?: number | null;
}) => {
  const imageLink = token.token_image?.startsWith("ipfs")
    ? token.token_image.replace("ipfs://", "https://ipfs.io/ipfs/")
    : token.token_image;
  const displayName = token.token_symbol || token.token_name || "";
  const hasImage = !!imageLink;
  const initial = displayName.charAt(0).toUpperCase();
  let factorLabel = "Token factor: —";
  if (typeof factor === "number") {
    factorLabel = `Token factor: ${factor.toLocaleString("en")}`;
  }
  let priceLabel = "Price per token: unavailable";
  if (typeof priceLovelace === "number") {
    const priceAda = priceLovelace / 1_000_000;
    const priceText = priceAda.toLocaleString("en", {
      maximumFractionDigits: 6,
    });
    priceLabel = `Price per token: ${priceText} ADA`;
  }
  let allocationLabel: string | null = null;
  if (
    typeof factor === "number" &&
    typeof fundFactor === "number" &&
    typeof priceLovelace === "number"
  ) {
    const adaValue = (factor * fundFactor * priceLovelace) / 1_000_000;
    allocationLabel = `Allocation value: ${adaValue.toLocaleString("en", {
      maximumFractionDigits: 6,
    })} ADA`;
  }
  return (
    <div className="flex items-center justify-between w-full py-3">
      <div className="flex items-center gap-2">
        {hasImage ? (
          <img src={imageLink} alt="" className="h-12" />
        ) : (
          <div className="h-12 w-12 rounded-full bg-violet-200 dark:bg-gray-700 flex items-center justify-center text-violet-600 dark:text-violet-300 font-semibold text-lg">
            {initial || "?"}
          </div>
        )}
        <h6 className="font-sf-pro text-lg md:text-xl text-gray-800 dark:text-white font-semibold">
          {displayName}
        </h6>
        {/*{token.verified ? (*/}
        {/*  <Icon icon={ICON_COLLECTION.circleCheck} iconColor="#7C3AED" />*/}
        {/*) : null}*/}
      </div>
      <div className="text-right">
        <p className="font-sf-pro text-lg md:text-xl text-gray-800 dark:text-white font-semibold">
          {token.distribution} %
        </p>
        <p className="text-xs text-gray-500 dark:text-gray-400">
          {factorLabel}
        </p>
        <p className="text-xs text-gray-500 dark:text-gray-400">
          {priceLabel}
        </p>
        {allocationLabel ? (
          <p className="text-xs text-gray-500 dark:text-gray-400">{allocationLabel}</p>
        ) : null}
      </div>
    </div>
  );
};
